import { render } from "./404.vue?vue&type=template&id=18440db8"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"

import "./404.vue?vue&type=style&index=0&id=18440db8&lang=css"
script.render = render

export default script